import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';

// ----------------------------------------------------------------------

export function ActivityCardSkeleton({ sx, ...other }) {
  return (
    <Card sx={{ textAlign: 'center', position: 'relative', ...sx }} {...other}>
      {/* Action Menu Button Skeleton */}
      <Skeleton
        variant="circular"
        width={24}
        height={24}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          zIndex: 20,
        }}
      />

      {/* Status Label Skeleton */}
      <Skeleton
        variant="rounded"
        width={70}
        height={22}
        sx={{
          position: 'absolute',
          top: 15,
          left: 10,
          zIndex: 10,
          borderRadius: 1,
        }}
      />

      {/* Activity Icon Skeleton */}
      <Box sx={{ position: 'relative', mt: 4 }}>
        <Skeleton
          variant="circular"
          width={64}
          height={64}
          sx={{
            zIndex: 11,
            mt: 2,
            mx: 'auto',
          }}
        />
      </Box>

      {/* Activity Title and Start Date Skeleton */}
      <Box sx={{ mt: 1, mb: 1.5, px: 2 }}>
        <Skeleton variant="text" width="70%" height={24} sx={{ mx: 'auto', mb: 0.5 }} />
        <Skeleton variant="text" width="50%" height={18} sx={{ mx: 'auto' }} />
      </Box>

      <Divider sx={{ borderStyle: 'dashed' }} />

      {/* Assigned Members Section Skeleton */}
      <Box sx={{ py: 2, px: 2 }}>
        <Skeleton variant="text" width="60%" height={18} sx={{ mx: 'auto', mb: 1.5 }} />

        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
          {/* Avatar Group Skeleton */}
          <Stack direction="row" spacing={-1}>
            {[1, 2, 3, 4].map((item) => (
              <Skeleton key={item} variant="circular" width={32} height={32} />
            ))}
          </Stack>

          {/* Manage Button Skeleton */}
          <Skeleton variant="rounded" width={90} height={32} sx={{ ml: 1, borderRadius: 1 }} />
        </Stack>
      </Box>

      <Divider sx={{ borderStyle: 'dashed' }} />

      {/* Activity Details Skeleton */}
      <Box
        sx={{
          display: 'flex',
          py: 1.5,
          px: 2,
          justifyContent: 'space-around',
          alignItems: 'center',
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <Skeleton variant="text" width={50} height={16} sx={{ mx: 'auto', mb: 0.5 }} />
          <Skeleton variant="text" width={60} height={20} sx={{ mx: 'auto' }} />
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <Skeleton variant="text" width={50} height={16} sx={{ mx: 'auto', mb: 0.5 }} />
          <Skeleton variant="text" width={40} height={20} sx={{ mx: 'auto' }} />
        </Box>
      </Box>
    </Card>
  );
}
